import { Component, Inject, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { InProgressAnimationComponent } from "../in-progress-animation/in-progress-animation.component";

@Component({
    selector: "app-terms-and-condition",
    templateUrl: "./terms-and-condition.page.html",
    styleUrls: ["./terms-and-condition.page.scss"],
    standalone: true,
    imports: [IonicModule, InProgressAnimationComponent],
})
export class TermsAndConditionPage implements OnInit {
  userId: string;
  constructor(
    private bottomSheetRef: MatBottomSheetRef<TermsAndConditionPage>,
    private analytics: AngularFireAnalytics,
    private authService: AuthService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {}

  async ngOnInit() {
    await this.authService
      ?.getUid("TermsAndConditionPage")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("syndicate_terms", {
          userId: this.userId,
        });
      })
      .catch((error) => {
        return error;
      });
  }

  closeDialog() {
    this.bottomSheetRef.dismiss();
  }
}
